const LoadingSpinner = ({ text }) => {

    return (

        <div className="text-center py-4">

            <div
                className="spinner-border text-light"
                role="status"
            />

            <div className="mt-3 text-light">

                {text}

            </div>

        </div>

    );

};

export default LoadingSpinner;